export const setItem = (name, value) => localStorage.setItem(name, value);

export const getItem = (name) => localStorage.getItem(name);